import * as React from 'react';

import { FetchJson } from '@volkswagen-onehub/fetch-json';

export const FetchJsonContext = React.createContext<FetchJson | undefined>(undefined);
